var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.786 0C9.33094 0 0.857422 8.47351 0.857422 18.9286C0.857422 29.3837 9.33094 37.8572 19.786 37.8572C30.2411 37.8572 38.7147 29.3837 38.7147 18.9286C38.7147 8.47351 30.2411 0 19.786 0ZM14.4919 26.8476H10.8023V15.0394H14.4919V26.8476ZM12.5473 13.5606H12.5177C11.1794 13.5606 10.3143 12.6585 10.3143 11.5124C10.3143 10.3442 11.209 9.46431 12.5695 9.46431C13.93 9.46431 14.7655 10.3442 14.7951 11.5124C14.8025 12.6511 13.9374 13.5606 12.5473 13.5606ZM29.2503 26.8476H25.0653V20.7401C25.0653 19.143 24.4147 18.0487 22.9728 18.0487C21.8711 18.0487 21.2574 18.7881 20.9765 19.498C20.873 19.7493 20.8877 20.1043 20.8877 20.4666V26.8476H16.7397C16.7397 26.8476 16.7915 16.0228 16.7397 15.0394H20.8877V16.8953C21.1317 16.0819 22.4553 14.9285 24.57 14.9285C27.1948 14.9285 29.2503 16.6291 29.2503 20.2817V26.8476Z",
    fill: "url(#paint0_linear_2061_2912)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2061_2912",
    x1: 17.7017,
    y1: 2.5,
    x2: 37.0429,
    y2: 14.7908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ab8dd680e84c11b48b16ec7a6541c8c9.svg";
export { ForwardRef as ReactComponent };